import './system.css'

export type SkeletonShape = 'row' | 'card' | 'text'

export function Skeleton({
  rows = 3,
  variant = 'row',
  title = false,
}: {
  rows?: number
  variant?: SkeletonShape
  title?: boolean
}) {
  return (
    <div className="stack stack--gap-md" aria-busy="true">
      {title ? <div className="skeleton__line skeleton__line--title" /> : null}
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className={`skeleton__line skeleton__line--${variant}`} />
      ))}
    </div>
  )
}
